var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 8.003a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-12-1a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H4z","fill":"#919CB5"}));
}

Minus.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
